module.exports = __webpack_public_path__ + "img/audio-mark9.ec1908bb.png";